<div class="d-flex flex-column overflow-auto p-3 p-lg-5">

    <h3>{{ "legal-tandc-title" | translate }}</h3>

    <h5>{{ "legal-tandc-sub-title-1" | translate }}</h5>
    <p>{{ "legal-tandc-p-1" | translate }}</p>
    <p>{{ "legal-tandc-p-2" | translate }}</p>
    <p>{{ "legal-tandc-p-2.5" | translate }}</p>
    <p>{{ "legal-tandc-p-3" | translate }}</p>
    <p>{{ "legal-tandc-p-4" | translate }}</p>
    <p>{{ "legal-tandc-p-5" | translate }}</p>
    <p>{{ "legal-tandc-p-6" | translate }}</p>
    <p>{{ "legal-tandc-p-7" | translate }}</p>
    <p>{{ "legal-tandc-p-8" | translate }}</p>
    <p>{{ "legal-tandc-p-9" | translate }}</p>

    <h5>{{ "legal-tandc-sub-title-3" | translate }}</h5>
    <p>{{ "legal-tandc-p-10" | translate }}</p>
    <p>{{ "legal-tandc-p-11" | translate }}</p>
    <p>{{ "legal-tandc-p-12" | translate }}</p>
    <p>{{ "legal-tandc-p-13" | translate }}</p>
    <p>{{ "legal-tandc-p-14" | translate }}</p>
    <p>{{ "legal-tandc-p-15" | translate }}</p>

    <h5>{{ "legal-tandc-sub-title-4" | translate }}</h5>
    <p>{{ "legal-tandc-p-16" | translate }}</p>
    <p>{{ "legal-tandc-p-17" | translate }}</p>
    <p>{{ "legal-tandc-p-18" | translate }}</p>
    <p>{{ "legal-tandc-p-19" | translate }}</p>
    <p>{{ "legal-tandc-p-20" | translate }}</p>
    <p>{{ "legal-tandc-p-21" | translate }}</p>
    <p>{{ "legal-tandc-p-22" | translate }}</p>

    <h5>{{ "legal-tandc-sub-title-5" | translate }}</h5>
    <p>{{ "legal-tandc-p-23" | translate }}</p>
    <p>{{ "legal-tandc-p-24" | translate }}</p>
    <p>{{ "legal-tandc-p-25" | translate }}</p>
    <p>{{ "legal-tandc-p-26" | translate }}</p>
    <p>{{ "legal-tandc-p-27" | translate }}</p>
    <p>{{ "legal-tandc-p-28" | translate }}</p>
    <p>{{ "legal-tandc-p-29" | translate }}</p>
    <p>{{ "legal-tandc-p-30" | translate }}</p>
    <p>{{ "legal-tandc-p-31" | translate }}</p>

    <h5>{{ "legal-tandc-sub-title-6" | translate }}</h5>
    <p>{{ "legal-tandc-p-32" | translate }}</p>
    <p>{{ "legal-tandc-p-33" | translate }}</p>
    <p>{{ "legal-tandc-p-34" | translate }}</p>
    <p>{{ "legal-tandc-p-35" | translate }}</p>

    <h5>{{ "legal-tandc-sub-title-7" | translate }}</h5>
    <p>{{ "legal-tandc-p-36" | translate }}</p>

    <h5>{{ "legal-tandc-sub-title-8" | translate }}</h5>
    <p>{{ "legal-tandc-p-37" | translate }}</p>

    <span class="zx-hidden">-</span>
</div>

<div class="position-absolute bottom-0 w-100 d-flex justify-content-between align-items-center p-2 p-sm-3">
    <button mat-raised-button color="primary" type="submit"
        class="text-white rounded-pill zx-text-tiny zx-text-sm-small" (click)="navigateHome()">
        {{ "main-nav.new-order" | translate }}
    </button>
    <button mat-raised-button (click)="openWhatsApp()" class="rounded-pill zx-text-tiny zx-text-sm-small">
        <div class="w-100 h-100 d-flex align-items-center gap-2">
            <div class="whatsup-logo-container-small">
                <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small">
            </div>
            <span>
                {{'main-nav.contact-us' | translate}}
            </span>
        </div>
    </button>
</div>